import React, { memo } from "react";

const AppCalendarPlusIcon = ({ color = "#666666", className }) => {
	return (
		<svg className={className} width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
			<path d="M8 2v4" />
			<path d="M16 2v4" />
			<path d="M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" />
			<path d="M3 10h18" />
			<path d="M16 19h6" />
			<path d="M19 16v6" />
		</svg>
	);
};

export default memo(AppCalendarPlusIcon);
